// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"9527a2c9","539":"3e8df4da"}[chunkId] + ".chunk.js";
};